import { useTranslation } from "react-i18next";

export default function CtaBar() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20background%20with%20soft%20flowing%20organic%20shapes%20and%20gentle%20gradients%20in%20coral%20cream%20and%20sage%20green%20tones%2C%20modern%20clean%20aesthetic%20with%20subtle%20textured%20overlays%2C%20peaceful%20atmosphere%20with%20harmonious%20color%20transitions%20and%20elegant%20composition&width=1800&height=600&seq=cta-bar-bg-kakobuy-v2-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4">
          {t("cta_bar.title")}
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-8 md:mb-10 max-w-xl mx-auto">
          {t("cta_bar.subtitle")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm md:text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
          >
            {t("cta_bar.button")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm md:text-base font-semibold text-white border-2 border-white/70 hover:border-white hover:bg-white/10 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t("cta_bar.button2")}
          </a>
        </div>
      </div>
    </section>
  );
}